module.exports = __webpack_public_path__ + "static/62-c358f2bdfbcf165b751fd69a7bbd73f4.png";